import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=e08cb79e&scoped=true"
import script from "./tag.vue?vue&type=script&lang=js"
export * from "./tag.vue?vue&type=script&lang=js"
import style0 from "./tag.vue?vue&type=style&index=0&id=e08cb79e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08cb79e",
  null
  
)

export default component.exports